<template>
  <div class="register" id="register" ms-controller="yum-reg" style="background: #eff2f5">
    <div class="register2">
      <el-form :model="form" :rules="rules" :ref="form.formname" label-width="100px" class="demo-ruleForm">
        <div style="padding:20px">
          <el-form-item class="form-item-title">
            <span style="font-size:16px">登录信息</span><span style="padding-left:10pxcolor:#adacac">用于登录网站</span>
          </el-form-item>
          <el-form-item prop="LoginName" class="el-form-item__content_left">
            <el-input placeholder="用户登录网站用户名(注册后不可更改)" class="el-input-width-400" v-model="form.LoginName">
              <template slot="prepend">
                登&nbsp;录&nbsp;名&nbsp;
              </template>
            </el-input>
          </el-form-item>
          <el-form-item prop="LoginPassword" class="el-form-item__content_left">
            <el-input type="password" placeholder="请输入用户登录密码" class="el-input-width-400" v-model="form.LoginPassword">
              <template slot="prepend">
                登录密码
              </template>
            </el-input>
          </el-form-item>
          <el-form-item prop="ConfirmPassword" class="el-form-item__content_left">
            <el-input type="password" placeholder="请再次输入登录密码" class="el-input-width-400" v-model="form.ConfirmPassword">
              <template slot="prepend">
                确认密码
              </template>
            </el-input>
          </el-form-item>
          <el-form-item prop="BusinessTypes" class="el-form-item__content_left">
            <div class="input-with-select el-input el-input-group el-input-group--prepend" style="width: 0px">
              <div class="el-input-group__prepend">
                经营类型
              </div>
              <el-select v-model="form.BusinessTypes" multiple collapse-tags placeholder="请选择经营类型" class="el-select-width-305" v-on:change="businessTypesChange()">
                <el-option v-for="item in constant.businessTypes" :label="item.label" :value="item.value" :key="item.value">
                </el-option>
              </el-select>
            </div>
          </el-form-item>
          <el-form-item prop="Platforms" class="el-form-item__content_left" v-show="form.PlatformShow">
            <div class="input-with-select el-input el-input-group el-input-group--prepend" style="width: 0px">
              <div class="el-input-group__prepend">
                店铺平台
              </div>
              <el-select v-model="form.Platforms" multiple collapse-tags placeholder="请选择店铺平台" class="el-select-width-305">
                <el-option v-for="item in constant.platforms" :label="item.label" :value="item.value" :key="item.value">
                </el-option>
              </el-select>
            </div>
          </el-form-item>
          <el-form-item class="form-item-title">
            <span style="font-size:16px">验证信息</span><span style="padding-left:10pxcolor:#adacac">验证登陆安全</span>
          </el-form-item>
          <el-form-item prop="Email" class="el-form-item__content_left">
            <el-input placeholder="您的电子邮箱" class="el-input-width-400" v-model="form.Email">
              <template slot="prepend">
                邮&nbsp;&nbsp;&nbsp;&nbsp;箱&nbsp;&nbsp;
              </template>
              <el-button slot="append" v-on:click="sendEmailClick()">{{form.SendEmail}}</el-button>
            </el-input>
          </el-form-item>
          <el-form-item prop="EmailSecurityCode" class="el-form-item__content_left">
            <el-input placeholder="请输入验证码" class="el-input-width-400" v-model="form.EmailSecurityCode">
              <template slot="prepend">
                验&nbsp;证&nbsp;码&nbsp;
              </template>
            </el-input>
          </el-form-item>
          <div>
            <el-form-item class="form-item-title">
              <span style="font-size:16px">企业信息</span><span style="padding-left:10pxcolor:#adacac">企业资料</span>
            </el-form-item>
            <el-form-item prop="EnterpriseName" class="el-form-item__content_left">
              <el-input placeholder="请输入企业名称" class="el-input-width-400" v-model="form.EnterpriseName">
                <template slot="prepend">
                  企业名称
                </template>
              </el-input>
            </el-form-item>
            <el-form-item prop="UnifySocialCreditCode" class="el-form-item__content_left">
              <el-input placeholder="请输入统一社会信用代码" class="el-input-width-400" v-model="form.UnifySocialCreditCode">
                <template slot="prepend">
                  信用代码
                </template>
              </el-input>
            </el-form-item>
            <el-form-item prop="Regions" class="el-form-item__content_left">
              <div class="input-with-select el-input el-input-group el-input-group--prepend" style="width: 0px">
                <div class="el-input-group__prepend">
                  所在省市
                </div>
                <el-cascader placeholder="请选择所在省市" class="el-select-width-305" :options="regionmodule.regions" v-model="form.Regions" filterable></el-cascader>
              </div>
            </el-form-item>
            <el-form-item prop="Street" class="el-form-item__content_left">
              <el-input placeholder="请输入企业所在街道" class="el-input-width-400" v-model="form.Street">
                <template slot="prepend">
                  所在街道
                </template>
              </el-input>
            </el-form-item>
            <el-form-item prop="EnterpriseAddress" class="el-form-item__content_left">
              <el-input placeholder="请输入企业详细地址" class="el-input-width-400" v-model="form.EnterpriseAddress">
                <template slot="prepend">
                  详细地址
                </template>
              </el-input>
            </el-form-item>

            <el-form-item prop="EnterprisePhone" class="el-form-item__content_left">
              <el-input placeholder="请输入企业电话" class="el-input-width-400" v-model="form.EnterprisePhone">
                <template slot="prepend">
                  企业电话
                </template>
              </el-input>
            </el-form-item>
          </div>
          <el-form-item class="form-item-title">
            <span style="font-size:16px">联系信息</span><span style="padding-left:10pxcolor:#adacac">用于客户服务</span>
          </el-form-item>
          <el-form-item prop="NickName" class="el-form-item__content_left">
            <el-input placeholder="您的网名" class="el-input-width-400" v-model="form.NickName">
              <template slot="prepend">
                昵&nbsp;&nbsp;&nbsp;&nbsp;称&nbsp;&nbsp;
              </template>
            </el-input>
          </el-form-item>
          <el-form-item prop="Name" class="el-form-item__content_left">
            <el-input placeholder="我们对您的称呼" class="el-input-width-400" v-model="form.Name">
              <template slot="prepend">
                姓&nbsp;&nbsp;&nbsp;&nbsp;名&nbsp;&nbsp;
              </template>
            </el-input>
          </el-form-item>
          <el-form-item prop="Sex" class="el-form-item__content_left">
            <div class="input-with-select el-input el-input-group el-input-group--prepend" style="width: 0px">
              <div class="el-input-group__prepend">
                性&nbsp;&nbsp;&nbsp;&nbsp;别&nbsp;&nbsp;
              </div>
              <el-select placeholder="您的性别" v-model="form.Sex">
                <el-option v-for="item in constant.sexs" :label="item.label" :value="item.value" :key="item.value">
                </el-option>
              </el-select>
            </div>
          </el-form-item>
          <el-form-item prop="MobilePhone" class="el-form-item__content_left">
            <el-input placeholder="您的手机号码" class="el-input-width-400" v-model="form.MobilePhone">
              <template slot="prepend">
                手机号码
              </template>
            </el-input>
          </el-form-item>
          <el-form-item class="el-form-item__content_left form-item-center">
            <el-button type="primary" class="el-button-width" v-on:click="submitForm()">立即注册</el-button>
          </el-form-item>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    var loginNameValidate = (rule, value, callback) => {
      var self = this;
      this.$ajax({
        method: 'post',
        url: this.constant.openPaths.existsLoginName,
        data: {
          LoginName: this.form.LoginName
        }
      }).then(function (res) {
        if (res.data.code === 200) {
          callback()
        } else {
          callback(new Error(res.data.msg))
        }
      }).catch(function (error) {
        self.$message.error(error)
      })
    }
    var confirmPasswordValidate = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'))
      } else if (value !== this.form.LoginPassword) {
        callback(new Error('两次输入密码不一致'))
      } else {
        callback()
      }
    }
    var emailValidate = (rule, value, callback) => {
      var self = this
      self.form.EmailValistate = false
      if (value === '') {
        callback(new Error('请输入电子邮箱'))
      }
      var reg = /^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/
      if (!reg.test(value)) {
        callback(new Error('请输入有效的邮箱'))
      }
      this.$ajax({
        method: 'post',
        url: this.constant.openPaths.existsEmail,
        data: {
          Email: this.form.Email
        }
      }).then(function (res) {
        if (res.data.code === 200) {
          self.form.EmailValistate = true
          callback()
        } else {
          callback(new Error(res.data.msg))
        }
      }).catch(function (error) {
        self.$message.error(error)
      })
    }
    var emailSecurityCodeValidate = (rule, value, callback) => {
      var self = this
      this.$ajax({
        method: 'post',
        url: this.constant.openPaths.registerEmailSCodeValidate,
        data: {
          Email: this.form.Email,
          securityCode: this.form.EmailSecurityCode
        }
      }).then(function (res) {
        if (res.data.code === 200) {
          callback()
        } else {
          callback(new Error(res.data.msg))
        }
      }).catch(function (error) {
        self.$message.error(error)
      })
    }
    var enterpriseNameValidate = (rule, value, callback) => {
      var self = this
      this.$ajax({
        method: 'post',
        url: this.constant.openPaths.existsRegisterEnterpriseName,
        data: {
          EnterpriseName: this.form.EnterpriseName
        }
      }).then(function (res) {
        if (res.data.code === 200) {
          callback()
        } else {
          callback(new Error(res.data.msg))
        }
      }).catch(function (error) {
        self.$message.error(error)
      })
    }
    var unifySocialCreditCodeValidate = (rule, value, callback) => {
      var self = this
      this.$ajax({
        method: 'post',
        url: this.constant.openPaths.existsRegisterUnifySocialCreditCode,
        data: {
          UnifySocialCreditCode: this.form.UnifySocialCreditCode
        }
      }).then(function (res) {
        if (res.data.code === 200) {
          callback()
        } else {
          callback(new Error(res.data.msg))
        }
      }).catch(function (error) {
        self.$message.error(error)
      })
    }
    var mobilePhoneValidate = (rule, value, callback) => {
      var self = this
      var reg = /^1[3|4|5|7|8][0-9]\d{8}$/
      if (!reg.test(value)) {
        callback(new Error('请输入有效的手机号码'))
      }
      this.$ajax({
        method: 'post',
        url: this.constant.openPaths.existsRegisterMobilePhone,
        data: {
          MobilePhone: this.form.MobilePhone
        }
      }).then(function (res) {
        if (res.data.code === 200) {
          callback()
        } else {
          callback(new Error(res.data.msg))
        }
      }).catch(function (error) {
        self.$message.error(error)
      })
    }
    return {
      title: '注册',
      form: {
        formname: 'registerform',
        SendEmail: '验证',
        totalTime: 90,
        PlatformShow: false,
        LoginName: '',
        LoginPassword: '',
        ConfirmPassword: '',
        BusinessTypes: [],
        Email: '',
        EmailValistate: false,
        EmailSecurityCode: '',
        EnterpriseName: '',
        UnifySocialCreditCode: '',
        Regions: [],
        Street: '',
        EnterpriseAddress: '',
        Platforms: [],
        EnterprisePhone: '',
        NickName: '',
        Name: '',
        Sex: '',
        MobilePhone: ''
      },
      rules: {
        LoginName: [
          { required: true, message: '请输入网站登录名', trigger: 'blur' },
          { min: 5, max: 20, message: '长度在5到 20 个字符', trigger: 'blur' },
          { validator: loginNameValidate, trigger: 'blur' }
        ],
        LoginPassword: [
          { required: true, message: '请输入网站登录密码', trigger: 'blur' },
          { min: 5, max: 20, message: '长度在5到20个字符', trigger: 'blur' }
        ],
        ConfirmPassword: [
          { validator: confirmPasswordValidate, trigger: 'blur' }
        ],
        BusinessTypes: [
          { required: true, message: '请选择经营类型', trigger: 'change' }
        ],
        Email: [
          { max: 50, message: '长度在50个字符内', trigger: 'blur' },
          { validator: emailValidate, trigger: 'blur' }
        ],
        EmailSecurityCode: [
          { required: true, message: '请输入验证码', trigger: 'blur' },
          { validator: emailSecurityCodeValidate, trigger: 'blur' }
        ],
        EnterpriseName: [
          { required: true, message: '请输入企业名称', trigger: 'blur' },
          { max: 100, message: '长度在100个字符内', trigger: 'blur' },
          { validator: enterpriseNameValidate, trigger: 'blur' }
        ],
        UnifySocialCreditCode: [
          { required: true, message: '请输入统一社会信用代码', trigger: 'blur' },
          { max: 30, message: '长度在30个字符内', trigger: 'blur' },
          { validator: unifySocialCreditCodeValidate, trigger: 'blur' }
        ],
        Regions: [
          { required: true, message: '请选择城市', trigger: 'change' }
        ],
        Street: [
          { required: true, message: '请填写企业所在街道', trigger: 'blur' },
          { max: 30, message: '长度在30个字符内', trigger: 'blur' }
        ],
        EnterpriseAddress: [
          { required: true, message: '请填写企业详细地址', trigger: 'blur' },
          { max: 100, message: '长度在100个字符内', trigger: 'blur' }
        ],
        EnterprisePhone:[
          { required: true, message: '请填写企业联系电话', trigger: 'blur' },
          { max: 100, message: '长度在50个字符内', trigger: 'blur' }
        ],
        NickName: [
          { required: true, message: '请输入昵称', trigger: 'blur' },
          { max: 50, message: '长度在50个字符内', trigger: 'blur' }
        ],
        Name: [
          { required: true, message: '请输入姓名', trigger: 'blur' },
          { max: 50, message: '长度在50个字符内', trigger: 'blur' }
        ],
        Sex: [
          { required: true, message: '请选择性别', trigger: 'change' }
        ],
        MobilePhone: [
          { required: true, message: '请输入手机号码', trigger: 'blur' },
          { max: 50, message: '长度在50个字符内', trigger: 'blur' },
          { validator: mobilePhoneValidate, trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    businessTypesChange () {
      this.form.PlatformShow = false
      this.form.BusinessTypes.forEach(item => {
        if (item === 1) {
          this.form.PlatformShow = true
        }
      })
    },
    sendEmailClick (formName) {
      var self = this
      if (self.form.EmailValistate) {
        this.$ajax({
          method: 'post',
          url: this.constant.openPaths.sendRegisterEmail,
          data: {
            Email: this.form.Email
          }
        }).then(function (res) {
          console.log(res)
          if (res.data.code === 200) {
            if (self.form.SendEmail === '验证') {
              self.form.totalTime = 90
              var clock = window.setInterval(() => {
                self.form.totalTime--
                self.form.SendEmail = self.form.totalTime
                if (self.form.totalTime < 1) {
                  window.clearInterval(clock)
                  self.form.SendEmail = '验证'
                }
              }, 1000)
            }
          } else {
            self.$message.error(res.data.msg)
          }
        }).catch(function (error) {
          self.$message.error(error)
        })
      }
    },
    submitForm () {
      var self = this
      this.$refs[this.form.formname].validate((valid) => {
        if (valid) {
          this.$ajax({
            method: 'post',
            url: this.constant.openPaths.registerSubmit,
            data: {
              LoginName: this.form.LoginName,
              LoginPassword: this.form.LoginPassword,
              BusinessTypes: this.form.BusinessTypes,
              Email: this.form.Email,
              EmailSecurityCode: this.form.EmailSecurityCode,
              EnterpriseName: this.form.EnterpriseName,
              UnifySocialCreditCode: this.form.UnifySocialCreditCode,
              Regions: this.form.Regions,
              Street: this.form.Street,
              EnterpriseAddress: this.form.EnterpriseAddress,
              Platforms: this.form.Platforms,
              EnterprisePhone: this.form.EnterprisePhone,
              NickName: this.form.NickName,
              Name: this.form.Name,
              Sex: this.form.Sex,
              MobilePhone: this.form.MobilePhone
            }
          }).then(function (res) {
            if (res.data.code === 200) {
              self.$message({ type: 'success', message: res.data.msg })
              self.$router.push({ name: 'login' })
            } else {
              self.$message.error(res.data.msg)
            }
          }).catch(function (error) {
            self.$message.error(error)
          })
        }
      })
    }
  }
}
</script>

<style coped>
@import "../../css/home/home.css";
.register {
  padding-bottom: 30px;
  border-top: 2px solid #6583fb;
  border-bottom: 2px solid #e9e9e9;
}

.register2 {
  width: 780px;
  margin: 50px auto 0;
  background-color: #fff;
}

.register .el-tabs__nav {
  white-space: nowrap;
  position: relative;
  -webkit-transition: -webkit-transform 0.3s;
  transition: -webkit-transform 0.3s;
  transition: transform 0.3s;
  transition: transform 0.3s, -webkit-transform 0.3s;
  float: left;
  z-index: 2;
  width: 100%;
  line-height: 56px;
}

.register .el-tabs--border-card > .el-tabs__header {
  background-color: #f5f7fa;
  border: 0;
  margin: 0;
}

.register .el-tabs--border-card > .el-tabs__header .el-tabs__item.is-active {
  color: #fff;
  background-color: #6a74ff;
  border-right-color: #dcdfe6;
  border-left-color: #dcdfe6;
  width: 50%;
  text-align: center;
  font-size: 20px;
  line-height: 56px;
}

.register .el-tabs__item {
  padding: 0 20px;
  width: 50%;
  height: 56px;
  text-align: center;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  line-height: 56px;
  display: inline-block;
  list-style: none;
  font-size: 20px;
  font-weight: 500;
  color: #303133;
  position: relative;
}

.register .el-tabs--border-card > .el-tabs__header .el-tabs__item {
  -webkit-transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
  transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
  border: 0;
  margin: 0;
  color: #909399;
}

.register .form-item-title {
  border-bottom: 1px dashed #ccc;
}

.register .form-item-center {
  margin-left: -200px;
  text-align: center;
}

.el-input-group--prepend .el-input__inner,
.el-input-group__append {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
}

.el-input-group--append .el-select .el-input.is-focus .el-input__inner,
.el-input-group--prepend .el-select .el-input.is-focus .el-input__inner {
  border-color: #409eff;
}

.register .el-input-width-400 {
  width: 400px;
}

.register .el-select-width-305 {
  width: 305px;
}

.register .el-button-width {
  width: 200px;
}

.register .el-form-item__content_left {
  padding-left: 100px;
}

.register .el-form-item__content {
  line-height: 40px;
  position: relative;
  font-size: 14px;
  margin-left: 80px !important;
}

.register .title_active {
  float: left;
  width: 50%;
  background: #6a74ff;
  height: 50px;
  text-align: center;
  font-size: 20px;
  color: white;
  line-height: 50px;
}

.register .title {
  float: left;
  width: 50%;
  height: 50px;
  text-align: center;
  font-size: 20px;
  color: black;
  line-height: 50px;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/home/register.vue